import * as L from "list";
import { ListImpl } from "./ListImpl";

export class List<A> extends ListImpl<A> {
  /**
   * Create a new empty List.
   */
  public static empty<A>(): List<A> {
    return new List(L.empty());
  }

  public static from<A>(sequence: A[] | ArrayLike<A> | Iterable<A>): List<A> {
    return new List(L.from(sequence));
  }

  /**
   * Create a new List with elements copied from a source array.
   */
  public static fromArray<A>(sequence: A[]): List<A> {
    return new List(L.from(sequence));
  }

  /**
   * Create a new List with elements copied from a source sequence.
   */
  public static fromIterable<A>(sequence: Iterable<A>): List<A> {
    return new List(L.from(sequence));
  }

  /**
   * Create a new list containing the integers from `start` (inclusive)
   * until `end` (exclusive).
   *
   * If (end <= start) then an empty list will be created
   */
  public static range(start: number, end: number): List<number> {
    return new List(L.range(start, end));
  }

  /**
   * Returns a new List with only the values for which the predicate function returns true.
   *
   * If no elements were removed, then the original List is returned.
   */
  public static filter<A>(predicate: (a: A) => boolean): (list: List<A>) => List<A> {
    return (list) => list.filter(predicate);
  }
}

export type { Ord } from "./ListImpl";
export { KeyedList } from "./ListImpl";
